import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPaginationModule} from 'ngx-pagination';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {NgxPayPalModule} from 'ngx-paypal';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {TraderListComponent} from '../components/trader/list/traderlist.component';
import {TraderEditComponent} from '../components/trader/edit/edit.component';
import {MarketlistComponent} from '../components/market/marketlist/marketlist.component';
import {QuotelistComponent} from '../components/quote/quotelist/quotelist.component';
import {UserComponent} from '../components/user/list/user.component';
import {UserEditComponent} from '../components/user/edit/user-edit.component';
import {DealComponent} from '../components/deal/deal/deal.component';
import {PaymentComponent} from '../modules/payment/payment/payment.component';
import {ProductListComponent} from '../modules/payment/product/list/productlist.component';
import {ProductEditComponent} from '../modules/payment/product/edit/edit.component';
import {PaymentListComponent} from '../modules/payment/payments/list/paymentlist.component';
import {PaymentEditComponent} from '../modules/payment/payments/edit/edit.component';
import {PaymentSuccessComponent} from '../modules/payment/payment-success/payment-success.component';
import {PaymentErrorComponent} from '../modules/payment/payment-error/payment-error.component';
import {MarketEditComponent} from '../components/market/market-edit/market-edit.component';
import {DealsConsolidateComponent} from '../components/deals-consolidate/deals-consolidate.component';
import {ModalWindowComponent} from '../components/dropdown-menu1/modal-window.component';

const PAGE_COMPONENTS = [
  TraderListComponent,
  TraderEditComponent,
  MarketlistComponent,
  QuotelistComponent,
  UserComponent,
  UserEditComponent,
  DealComponent,
  ProductListComponent,
  ProductEditComponent,
  PaymentListComponent,
  PaymentEditComponent,
  PaymentComponent,
  ModalWindowComponent,
  PaymentSuccessComponent,
  PaymentErrorComponent,
  MarketEditComponent,
  DealsConsolidateComponent,
];

@NgModule({
  declarations: PAGE_COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxPaginationModule,
    Ng2SmartTableModule,
    NgxPayPalModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: PAGE_COMPONENTS,
})
export class PagesModule {
}
